import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="The system" className="bg-transparent" data-id="element-299" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-300" data-mp="181sl7crfnqd4">
        <div className="text-center" data-id="element-301" data-mp="1c3499duns3j7">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-302" data-mp="1zut9rhhmvyb8">
            THE AI BOOK BUILDER™: THE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-303" data-mp="24s1thmifkael">
            📚 The 6-Volume AI Author Vault
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-304" data-mp="1vsy6w8k21cvc">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-305" data-mp="ffhi9vgctdd5">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-306" data-mp="3o97y8it9mird">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-gold/35 bg-white p-5" data-id="element-307" data-mp="3ja561yydw70t" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-308" data-mp="62tkokywsati">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-grape-deep font-display text-lg font-black text-gold-soft ring-1 ring-gold/60" data-id="element-309" data-mp="62a3x7kzvsh2">
                  {String(t.n).padStart(2, '0')}
                </span>
                <div className="min-w-0" data-id="element-310" data-mp="trmnn1dy7ixm">
                  <h3 className="text-sm font-black leading-tight text-plum" data-id="element-311" data-mp="tso11cifshii">
                    <span aria-hidden="true" data-id="element-312" data-mp="prkmctc4kriv">{t.emoji} </span>
                    {t.title}
                  </h3>
                  <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-blush" data-id="element-313" data-mp="wvamaxp0vu4q">{t.pack}</p>
                </div>
              </div>
              <p className="mt-3 text-sm font-semibold leading-relaxed text-plum/80" data-id="element-314" data-mp="16s6wr8yheqbx">{t.desc}</p>
              <p className="mt-3 text-[11px] font-bold uppercase tracking-wide text-plum/50" data-id="element-315" data-mp="1bidhgxpvhqow">{t.focusLabel}:</p>
              <p className="mb-3 mt-1 text-[13px] leading-relaxed text-plum/65" data-id="element-316" data-mp="1fkqm1isvvik3">{t.focus.join(' · ')}</p>
              <p className="mt-auto border-t border-gold/25 pt-3 text-[13px] font-semibold italic leading-snug text-grape-deep" style={{
            marginTop: 'auto'
          }} data-id="element-317" data-mp="1kisdos4dkq76">
                {t.closing}
              </p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-318" data-mp="1ugq2bgq5cp0b">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-319" data-mp="3rb2xnkw23c0i">
            ✅ Every volume includes:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-320" data-mp="5bckzx4ypkk">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-321" data-mp="2dfkxuds2jinr">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-322" data-mp="28kx4a0i7jy2b" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}